// src/components/reports/ReportPreview.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { useReportContext } from '../../contexts/ReportContext';
import WorkingTimeRecordPreview from './preview/WorkingTimeRecordPreview';
import AllTimeEntriesPreview from './preview/AllTimeEntriesPreview';
import DailySummaryPreview from './preview/DailySummaryPreview';
import VacationReportPreview from './preview/VacationReportPreview';
import ScheduleReportPreview from './preview/ScheduleReportPreview';
import SickLeaveReportPreview from './preview/SickLeaveReportPreview';

/**
 * Container component that displays the appropriate report preview
 * based on the selected report type and category
 */
const ReportPreview = () => {
  const { t } = useTranslation('reports');
  const { reportData, reportType, reportCategory, isGeneratingReport } = useReportContext();

  // If no data or still generating report, show appropriate message
  if (reportData.length === 0) {
    return (
      <div className="report-preview-placeholder">
        {isGeneratingReport ? (
          <div className="report-loading">
            <div className="spinner"></div>
            <p>{t('generatingReport')}</p>
          </div>
        ) : (
          <p>{t('generateReportPreview')}</p>
        )}
      </div>
    );
  }

  return (
    <div className="report-preview-container">
      <div className="report-preview-header">
        <h3>{t('reportPreview')}</h3>
        <span className="report-count">{t('entries', { count: reportData.length })}</span>
      </div>

      {/* Time tracking preview components */}
      {reportCategory === 'time-tracking' && reportType === 'Working Time Record' && (
        <WorkingTimeRecordPreview data={reportData} />
      )}

      {reportCategory === 'time-tracking' && reportType === 'All Time Entries' && (
        <AllTimeEntriesPreview data={reportData} />
      )}

      {reportCategory === 'time-tracking' && reportType === 'Daily Summary' && (
        <DailySummaryPreview data={reportData} />
      )}

      {/* Vacation preview component */}
      {reportCategory === 'vacation' && (
        <VacationReportPreview data={reportData} reportType={reportType} />
      )}

      {/* Schedule preview component */}
      {reportCategory === 'schedule' && (
        <ScheduleReportPreview data={reportData} reportType={reportType} />
      )}

      {/* Sick leave preview component */}
      {reportCategory === 'sick-leave' && (
        <SickLeaveReportPreview data={reportData} reportType={reportType} />
      )}
    </div>
  );
};

export default ReportPreview;